/**
 * Enum-Katalog. Einzige Quelle der Wahrheit — SCHEMA.md §0 spiegelt diese Listen,
 * die Drizzle-Spalten und die CHECK-Constraints leiten sich davon ab.
 */
export const CATEGORIES = [
    'shirt', 'tshirt', 'polo', 'knitwear', 'jacket', 'coat', 'suit_jacket',
    'trousers', 'jeans', 'shorts', 'shoes', 'boots', 'sneakers', 'belt', 'tie',
    'scarf', 'gloves', 'hat', 'socks', 'underwear', 'other',
];
/** SCHEMA.md D-05: `belt` ist ein eigener Layer, damit die Farbregel ihn adressieren kann. */
export const LAYERS = ['base', 'mid', 'outer', 'bottom', 'footwear', 'belt', 'accessory'];
export const SLOTS = ['top', 'mid', 'outer', 'bottom', 'footwear', 'belt', 'accessory'];
/** Der einzige Namensunterschied ist base ↔ top. Explizit statt implizit (D-05). */
export const LAYER_TO_SLOT = {
    base: 'top', mid: 'mid', outer: 'outer', bottom: 'bottom',
    footwear: 'footwear', belt: 'belt', accessory: 'accessory',
};
export const SLOT_TO_LAYER = {
    top: 'base', mid: 'mid', outer: 'outer', bottom: 'bottom',
    footwear: 'footwear', belt: 'belt', accessory: 'accessory',
};
export const LIFECYCLE_STATES = [
    'clean', 'worn_ok', 'soiled', 'in_hamper', 'washing', 'drying', 'ironing',
    'at_care', 'retired',
];
export const LOCATIONS = ['wardrobe', 'hamper', 'laundry', 'cleaner', 'tailor', 'trip'];
export const CARE_POLICIES = ['machine_wash', 'hand_wash', 'dry_clean', 'air_only'];
/** §4: nur diese beiden dürfen in einen Waschgang. Invariante 3. */
export const WASHABLE_POLICIES = ['machine_wash', 'hand_wash'];
export const LAUNDRY_GROUPS = ['dark', 'light', 'white', 'color', 'delicate', 'wool'];
export const OCCASIONS = [
    'home_office', 'office', 'client_meeting', 'evening', 'travel', 'sport', 'other',
];
export const WEATHER_SOURCES = ['forecast', 'actual'];
/** D-06: `mid` ergänzt — die Zwischenschicht ist der häufigste thermische Fehlgriff. */
export const BLAME_LAYERS = ['top', 'mid', 'bottom', 'outer', 'footwear'];
export const CARE_TYPES = ['dry_clean', 'tailor', 'repair', 'impregnate'];
export const SLOT_MODES = ['fixed', 'rule'];
export const JOB_STATUSES = ['pending', 'running', 'done', 'failed'];
export const TRIP_STATUSES = ['planned', 'active', 'done', 'cancelled'];
/** Ein Trip in diesen Zuständen blockiert seine Items daheim (§4). */
export const TRIP_BLOCKING_STATUSES = ['planned', 'active'];
export const ITEM_ACTIONS = [
    'wear', 'to_hamper', 'start_wash', 'finish_wash', 'drying_done', 'ironed',
    'send_to_care', 'care_returned', 'retire', 'unretire', 'manual_edit',
    'learning', 'trip_reserve', 'trip_release',
];
export const REF_TYPES = ['wear_log', 'wash_run', 'care_event', 'trip', 'learning_event'];
/** §4: Verfügbarkeit setzt einen dieser Zustände voraus. Invariante 4 ist das Komplement. */
export const AVAILABLE_STATES = ['clean', 'worn_ok'];
/**
 * Layer, die thermisch zählen. §6 Schritt 2 aggregiert nur diese, §7 Schritt 3
 * verteilt die Lernkorrektur nur auf sie — ein Gürtel wärmt nicht.
 *
 * D-39: `accessory` gehört dazu. Schal, Mütze und Handschuhe tragen im Katalog 3, 2 und 2
 * Wärmepunkte, die vorher ausnahmslos verfielen — bei Frost ist der Schal aber genau das
 * Teil, das den Unterschied macht.
 */
export const WARMING_LAYERS = [
    'base', 'mid', 'outer', 'bottom', 'footwear', 'accessory',
];
/** §6 Schritt 2: der gestapelte Teil, für den der abnehmende Grenznutzen gilt (D-39). */
export const TORSO_LAYERS = ['base', 'mid', 'outer'];
//# sourceMappingURL=enums.js.map